import * as React from 'react';
import { FC } from 'react';
import { BadgeInfo } from './types';

const Badge: FC<{ badge: BadgeInfo }> = ({ badge }) => (
  <li className="badge" style={{ background: badge.color }}>
    {badge.icon_url ? (
      <div className="badge_image">
        <img className="badge--icon" src={badge.icon_url} alt="" />
      </div>
    ) : null}
    {badge.label ? <span className="badge--label">{badge.label.toUpperCase()}</span> : null}
  </li>
);

const Badges: FC<{ ids: number[]; badges: BadgeInfo[] }> = ({ ids, badges }) => (
  <ul className="badges">
    {badges.map((badge) => {
      const show = ids.includes(badge.id);
      return show && badge ? <Badge key={badge.id} badge={badge} /> : null;
    })}
  </ul>
);

export default Badges;
